<template>
  <div id="app" :style="'height:' + innerHeight + 'px'" :class="[...comp]">
    <div class="font">.</div>
    <div class="font1">.</div>
    <div class="border">
      <!-- <img src="./assets/img/border-top.png" alt="" class="top" /> -->
      <div class="border-t"></div>
      <div class="border-center-l"></div>
      <div class="border-center-r"></div>
      <div class="border-b"></div>
      <!-- <img src="./assets/img/border-bottom.png" alt="" class="bottom" /> -->
    </div>

    <div class="loading page">
      <div class="border">
        <canvas id="loadCanvas"></canvas>
        <div class="spH">
          <div class="text t1">
            <div class="img1">
              <div class="ani"></div>
            </div>
            <div class="img2">
              <div class="ani"></div>
            </div>
            <div class="img3">
              <div class="ani"></div>
            </div>
          </div>

          <div class="text t2">
            <div class="img1">
              <div class="ani" @click="layerFadein"></div>
            </div>
            <div class="img2">
              <div class="ani"></div>
            </div>
            <div class="img3">
              <div class="ani"></div>
            </div>
            <img src="./assets/img/jtw1.png" alt="" class="shoushi" />
          </div>
        </div>
      </div>
      <div class="load_prog">
        <div class="load_number">
          <div
            v-for="(item, key) in loadingNumber.toString().split('')"
            :key="key"
            :class="'n' + item"
          ></div>
          <div class="n10"></div>
        </div>
        <div class="progBox">
          <div :style="'width:' + loadingNumber + '%'"></div>
        </div>
        <!-- <img src="./assets/img/1-11-22.png" alt="" class="txt" /> -->

        <div class="txt">
          <div class="img1"></div>
          <div class="img2"></div>
        </div>
        
        <div class="loadStartBtn">
          <img src="./assets/img/loadstart.png" alt="">
        </div>
      </div>
    </div>

    <page1 :index="index" :opsIdx="opsIdx"></page1>

    <page2></page2>

    <div class="page layer">
      <div class="box">
        <input
          type="text"
          placeholder="请输入宝贝的昵称"
          class="input"
          maxlength="6"
          v-model="name"
        />

        <div class="layfade">
          <img src="./assets/img/jtw1.png" alt="" class="jiantouts" />
        </div>

        <div class="layfade1a">
          <img src="./assets/img/jtw1.png" alt="" class="jiantoutsb" />
        </div>

        <div :class="['donghua', istishi ? 'cur' : '']">
          <img src="./assets/img/tongy.png" alt="" class="tongy" />
          <img
            src="./assets/img/curtongy.png"
            alt=""
            class="tongy"
            v-if="istongy"
          />
        </div>

        <div class="jsdongh">
          <div class="btnsba">
            <img src="./assets/img/btna.png" alt="" class="" />
            <div></div>
          </div>
        </div>

        <!-- <img src="./assets/img/jtw1.png" alt="" class="jtw"> -->

        <div class="btn" @click="istongy = !istongy"></div>
        <div class="btn1" @click="submit"></div>
        <div class="btn2" @click="gohref"></div>
      </div>
    </div>

    <div class="page gushi">
      <div class="gushi-box">
        <img src="./assets/img/close.png" alt="" class="close" />
        <div class="gus-move">
          <div class="imglists">
            <img src="./assets/img/gs_bg.png" alt="" class="gsbg w100" />

            <div class="img">
              <div class="tup">
                <img src="./assets/img/01-V1/v1-0.png" alt="" class="w100" />
                <canvas class="v1_canvas w100"></canvas>
              </div>
              <!-- <img src="./assets/img/gs1.png" alt="" class="w100" /> -->
              <img src="./assets/img/gs1_1.png" alt="" class="gs1_1 gs1" />
              <img src="./assets/img/gs1_2.png" alt="" class="gs1_1 gs2" />
            </div>
            <div class="img">
              <div class="tup">
                <img src="./assets/img/01-V2/v1-0.png" alt="" class="w100" />
                <canvas class="v2_canvas w100"></canvas>
              </div>
              <!-- <img src="./assets/img/gs3.png" alt="" class="w100" /> -->
              <img src="./assets/img/gs2_1.png" alt="" class="gs1_1 gs1" />
              <img src="./assets/img/gs2_2.png" alt="" class="gs1_1 gs2" />
            </div>
            <div class="img">
              <div class="tup">
                <img src="./assets/img/01-V3/v1-0.png" alt="" class="w100" />
                <canvas class="v3_canvas w100"></canvas>
              </div>
              <!-- <img src="./assets/img/gs5.jpg" alt="" class="w100" /> -->
              <img src="./assets/img/gs4_1.png" alt="" class="gs1_1 gs1" />
              <img src="./assets/img/gs4_2.png" alt="" class="gs1_1 gs2" />
            </div>
            <div class="img">
              <div class="tup">
                <img src="./assets/img/01-V4/v1-0.png" alt="" class="w100" />
                <canvas class="v4_canvas w100"></canvas>
              </div>
              <!-- <img src="./assets/img/gs4.png" alt="" class="w100" /> -->
              <img src="./assets/img/gs3_1.png" alt="" class="gs1_1 gs1" />
              <img src="./assets/img/gs3_2.png" alt="" class="gs1_1 gs2" />
            </div>

            <div class="img">
              <div class="tup">
                <img src="./assets/img/01-V5/v1-0.png" alt="" class="w100" />
                <canvas class="v5_canvas w100"></canvas>
              </div>
              <!-- <img src="./assets/img/gs6.png" alt="" class="w100" /> -->
              <img src="./assets/img/gs5_1.png" alt="" class="gs1_1 gs1" />
              <img src="./assets/img/gs5_2.png" alt="" class="gs1_1 gs2" />
            </div>
          </div>
          <div class="animate1_2">
            <img src="./assets/img/left.png" alt="" class="gs-left" />
          </div>
          <div class="animate1_1">
            <img src="./assets/img/right.png" alt="" class="gs-right" />
          </div>
        </div>
        <div class="closeBtn"></div>
        <!-- <img src="./assets/img/gs-btn.png" alt="" class="gsbtn" /> -->
        <div class="gsbtn">

        </div>
      </div>
    </div>

    <div :class="['audio', isaudioPlay ? 'cur' : '']" @click="audioplay">
      <!-- <audio src="./assets/audio/bg.mp3" loop ref="audio"></audio> -->
    </div>

    <div id="orientLayer" class="mod-orient-layer">
      <div class="mod-orient-layer__content">
        <i class="icon-wx mod-orient-layer__icon-orient"></i>
        <div class="mod-orient-layer__desc">为了更好的体验，请使用竖屏浏览</div>
      </div>
    </div>

    <!-- <canvas
      id="canvas"
      style="width: 100%; position: absolute; top: 0; z-index: 999"
    ></canvas> -->
  </div>
</template>

<script>
import page1 from "./components/page1";
import page2 from "./components/page2";
import * as util from "./assets/js/util";
import txjsdk from "./assets/js/txjssdk";

import * as loadData from "./assets/js/loadData";

import { frameVideo, imgLoad } from "./assets/js/pageLoad";

function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); //匹配目标参数
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
}

export default {
  name: "App",

  components: {
    page1,
    page2,
  },
  data() {
    return {
      innerHeight: window.innerHeight,
      comp: [],

      isaudioPlay: true,

      name: "",
      istongy: false,

      loadingNumber: 0,

      gsOption: {
        index: 0,
      },

      optionArr: [], //储存对错
      optionData: [0, 1, 2, 1, 1], //选项答案

      resList: [[[]], [[]], [[]], [[]], [[]], [[]]], //加载储存
      frameK: [[], [], [], [], [], []], //动画控制器

      bgList: [], //背景加载储存
      btnList: {
        isPlay: false,
        isComp: false,
        img: [],
        state: 0,
      }, //按钮

      index: 0, //当前题目索引
      opsIdx: [0, 0, 0, 0, 0], //当前题目选项索引

      bgoption: {
        seed: 6,
        number: 0,
        frame: 0,
      },

      btnoption: {
        seed: 6,
        number: 0,
        frame: 0,
      },

      bgCanvas: [],
      btnCanvas: [],

      istishi: false,

      isDyc: [],
      loadidx: 2,

      cyclePreload: [],
    };
  },
  watch: {
    name(val, oldVal) {
      if (!this.flag_p1) {
        $(".layfade").fadeOut(200);
        $(".layfade1a").fadeIn(200);
        $(".btnsba").addClass("cur");
        this.flag_p1 = true;
      }
    },
  },
  computed: {},
  created() {
    let { TweenMax, TweenLite, TimelineLite } = this.gsap;

   

    let data = {
      shareTitle: "潜能自测！发现你娃的学科天赋",
      shareDesc: "点击一测究竟",
      shareImage: "https://helloyoung.qq.com/young2022/share.jpg?v=1",
    };
    console.log("created");
    txjsdk.init(data);
  },
  mounted() {
    let that = this;

    window.addEventListener(
      "resize",
      () => {
        setTimeout(() => {
          console.log("resize");
          this.cssComp();
        }, 400);
      },
      false
    );

    setTimeout(() => {
      console.log("setTimeout");
      this.cssComp(); //页面适配
    }, 800);

    // $(".move").on("swiperight", () => {
    //   if (this.opsIdx == 0) return;
    //   this.prveOption();
    // });
    // $(".move").on("swipeleft", () => {
    //   if (this.opsIdx == 3) return;
    //   this.nextOption();
    // });

    //  let test = "10000";
    // this.optionArr = test.split('');

    $(".gushi .gushi-box .gus-move .img").show();

    // $(".gushi .gushi-box .gus-move .img").eq(0).show().siblings().hide();

    let gsRight = () => {
      if (this.gsOption.index === 0) return;
      // gsOption.index
      this.gsOption.index--;

      if (this.gsOption.index === 0) {
        $(".gushi .gushi-box .gus-move .gs-left").fadeOut(500);
      } else {
        $(".gushi .gushi-box .gus-move .gs-right").fadeIn(500);
      }

      $(".gushi .gushi-box .gus-move .img")
        .eq(this.gsOption.index)
        .fadeIn(500)
        .siblings(".img")
        .fadeOut(500);

        that.playGs(this.gsOption.index);
    };

    let gsLeft = () => {
      if (this.gsOption.index === 4) return;
      this.gsOption.index++;
      if (this.gsOption.index === 4) {
        $(".gushi .gushi-box .gus-move .gs-right").fadeOut(500);
      } else {
        $(".gushi .gushi-box .gus-move .gs-left").fadeIn(500);
      }
      $(".gushi .gushi-box .gus-move .img")
        .eq(this.gsOption.index)
        .fadeIn(500)
        .siblings(".img")
        .fadeOut(500);
        that.playGs(this.gsOption.index);
    };

    $(".gus-move").on("swipeleft", () => {
      gsLeft();
    });
    $(".gus-move").on("swiperight", () => {
      gsRight();
    });

    $(".gushi .gushi-box .gus-move .gs-right").on("click", () => {
      gsLeft();
    });
    $(".gushi .gushi-box .gus-move .gs-left").on("click", () => {
      gsRight();
    });
    $(".gushi .closeBtn").on("click", () => {
      TweenMax.to(".gushi", 0.5, { autoAlpha: 0 });
       util.clearInterval(that.gs_timer);
    });

    $(".page2 .bian").on("click", function () {
      let index = $(".page2 .bian").index(this);
      let n = index == 0 || index == 1 ? 0 : index - 1;

      that.playGs(n);

      that.gsOption.index = n;

      TweenMax.fromTo(".gushi", 0.5, { autoAlpha: 0 }, { autoAlpha: 1 });
      TweenMax.fromTo(".gushi .gushi-box", 0.5, { y: 200 }, { y: 0 });

      if (n == 0) {
        $(".gushi .gushi-box .gus-move .gs-left").hide();
        $(".gushi .gushi-box .gus-move .gs-right").show();
      } else if (n == 4) {
        $(".gushi .gushi-box .gus-move .gs-right").hide();
        $(".gushi .gushi-box .gus-move .gs-left").show();
      } else {
        $(".gushi .gushi-box .gus-move .gs-left").show();
        $(".gushi .gushi-box .gus-move .gs-right").show();
      }
      $(".gushi .gushi-box .gus-move .img")
        .eq(n)
        .show()
        .siblings(".img")
        .hide();
    });

    // this.loadingDataStart();
    // this.page_init(1, 1);
    // this.p1_bg_init();
    // this.btnFrom_init();
    // this.progress();
    // this.nextPage();

    let { TweenMax, TweenLite, TimelineLite } = this.gsap;
    // this.page_init(1, 1);
    // this.page_init(1, 2);
    // this.page_init(1, 3);
    // this.page_init(1, 4);

    // this.page_init(2, 1);
    // this.page_init(2, 2);
    // this.page_init(2, 3);
    // this.page_init(2, 4);

    // this.page_init(3, 1);
    // this.page_init(3, 2);
    // this.page_init(3, 3);
    // this.page_init(3, 4);

    //  this.page_init(4, 1);
    // this.page_init(4, 2);
    // this.page_init(4, 3);
    // this.page_init(4, 4);

    // this.page_init(5, 1);
    // this.page_init(5, 2);
    // this.page_init(5, 3);
    // this.page_init(5, 4);

    // this.p1_bg_init();
    // this.btnFrom_init();
    // this.progress();
    // this.nextPage();

    function toshare() {
      TweenMax.set(".page1", { autoAlpha: 1 });
      $(".bl2,.returnprve").hide();
      $(".bl1").show();

      that.index = 4;
      that.nextAnswer("bc");
    }

    let isJump = getUrlParam("jump");
    if (isJump) {
      //   that.sound.play();
      //   that.sound.pause();
      //     $('.audio').show();
      //   document.addEventListener(
      //   "WeixinJSBridgeReady",
      //   function () {
      //     console.log('WeixinJSBridgeReady')
      //     // that.$refs.audio.play();
      //     that.sound.play();
      //     that.sound.pause();
      //     //  this.sound.play();
      //   },
      //   false
      // );
       $('.audio').show();

        that.isaudioPlay = false;

      that.loadStyle('https://helloyoung.qq.com/young2022/font.css');
      that.laodFont = true;
      TweenMax.set(".loading", { autoAlpha: 0 });
      toshare();
      // txjsdk.handleGetUserInfo((userinfo)=> {
      //   console.log("userinfo", userinfo);
      //   if (userinfo) {
      //     // that.$root.openid = userinfo.openid;
      //     // that.$root.name = userinfo.nickname;
      //     this.headimgurl = userinfo.headimgurl;
      //     toshare();
      //   }
      // });
    } else {
      this.loadingDataStart();
      let tl = new TimelineLite();
      tl.add(TweenLite.to(".load_prog .txt .img1", 0.4, { width: "102%" }),1);
      tl.add(
        TweenLite.to(".load_prog .txt .img2", 0.4, { width: "102%" }),
        "+=0.2"
      );
      
    }

    // TweenMax.to(".loading", 0.3, { autoAlpha: 0 });
    // TweenMax.to(".page1", 0.3, { autoAlpha: 1 });
    // this.$nextTick(() => {
    //   this.index = 4;
    //   this.nextAnswer();
    // });
    $("input").on("blur", function () {
      setTimeout(() => {
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        console.log("scrollHeight", scrollHeight);
        window.scrollTo(0, 0);
      }, 100);
    });
  },
  methods: {
    loadStyle(url) {
      var link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = url; //css链接
      var head = document.getElementsByTagName('head')[0];
      console.log(url);

      head.appendChild(link);
    },
    async loadGs() {
      this.loadGsData = [];
      (async () => {
        for(let i = 1; i<=5; i++){
          let _arr = [];
          for(let j = 0; j<=13; j++){
            _arr.push({
              src:require('./assets/img/01-V'+i+'/v1-'+j+'.png'),
              id:'v'+i+'_'+j
            });
          }
          let p = await imgLoad(_arr);
          this.loadGsData.push(p);

          $('.gushi .gushi-box .gus-move .img').eq(this.loadGsData.length-1).find('.tup img').hide();
          
        }
      })();

      // await imgLoad();
    },

    async playGs(n) {
      let canvasArr = [];
      let that = this;
      for (let i = 1; i <= 5; i++) {
        let canvas = document.querySelector(".v" + i + "_canvas");
        canvasArr.push({
          canvas:canvas,
          ctx:canvas.getContext('2d')
        });
        canvasArr[i-1].canvas.width = 750;
        canvasArr[i-1].canvas.height = 1334;
      }

      util.clearInterval(this.gs_timer);

      let frame = 0;
      let loop = () => {
        if(that.loadGsData[n]){
         if(frame > that.loadGsData[n].getItems().length - 1) frame = 0;
          canvasArr[n].ctx.clearRect(0, 0, 750, 1334);
          canvasArr[n].ctx.drawImage(that.loadGsData[n].getResult('v'+(n+1)+'_'+frame), 0, 0, 750, 1334 );
          frame++;
        }
      };
      that.gs_timer = util.setInterval(loop, 5);
    },

    audioplay() {
      if (this.isaudioPlay) {
        this.sound.pause();
      } else {
        this.sound.play();
      }
      this.isaudioPlay = !this.isaudioPlay;
    },
    gohref() {
      location.href = "https://privacy.qq.com/policy/tencent-privacypolicy";
    },
    layerFadein() {
      let { TweenMax, TweenLite, TimelineLite } = this.gsap;
      TweenMax.to(".layer", 0.5, { autoAlpha: 1 });

      TweenMax.fromTo(
        ".layer .box .inputm,.jsdongh,.donghua",
        0.5,
        { autoAlpha: 0, y: 10 },
        { autoAlpha: 1, y: 0 }
      );
      $(".btnsba div").addClass("cur");

      TweenMax.killTweensOf(".loading .spH .t2 .img1");
      TweenMax.killTweensOf(".shoushi");
    },
    submit() {
      let { TweenMax, TweenLite, TimelineLite } = this.gsap;

      if (this.duocidia) return;

      if (!this.name) {
        this.Toast("请输入宝贝的昵称！");
        return;
      }
      let censoredWord = new this.censoredWord();
      if (!censoredWord.check(this.name).result) {
        this.Toast("包含敏感词汇！");
        return;
      }
      if (!this.istongy) {
        this.Toast("请同意隐私保护指南！");

        this.istishi = true;

        clearTimeout(this.mo);
        this.mo = setTimeout(() => {
          this.istishi = false;
        }, 800);

        return;
      }

       this.report("click_start",{path:'young2022'});      

      this.duocidia = true;
      TweenMax.to(".layer", 0.5, { autoAlpha: 0 });
      this.nextPage();
    },
    // loadingFrame() {
    //   let timer = null;
    //   let that = this;
    //   let number = 0;
    //   let { TweenMax, TweenLite, TimelineLite } = this.gsap;

    //   function loop() {
    //     if (number == 2) {
    //       if (!that.isStartLoad && that.loadingNumber == 80) {
    //         that.loadingNumber = 80;
    //       } else {
    //         if (that.loadingNumber == 100) {
    //           TweenMax.to(".load_prog", 0.5, { autoAlpha: 0 });

    //           that.loadingTxtAnimate();
    //           that.loadloop.init();
    //           that.cyclePreload = that.loadingDataCycle();

    //           window.cancelAnimationFrame(that.timer);
    //           return;
    //         }
    //         that.loadingNumber++;
    //       }
    //       number = 0;
    //     }
    //     number++;
    //     that.timer = window.requestAnimationFrame(loop);
    //   }
    //   loop();
    // },

    loadAllPage() {
      let data = [];
      //加载第一题
      let loadv1 = this.rnPage(this.loadidx, 1);
      let loadv2 = this.rnPage(this.loadidx, 2);
      let loadv3 = this.rnPage(this.loadidx, 3);
      let loadv4 = this.rnPage(this.loadidx, 4);
      data.push(...loadv1, ...loadv2, ...loadv3, ...loadv4);
      let preload = new createjs.LoadQueue(false);
      preload.setMaxConnections(5);
      preload.loadManifest(data);
      preload.addEventListener("complete", (e) => {
        let _arr = e.currentTarget.getItems();
        // console.log(_arr);

        for (let i in _arr) {
          let arr = _arr[i].item.id.split("_");
          this.resList[arr[2] - 1] = this.resList[arr[2] - 1] || [];
          this.resList[arr[2] - 1][arr[3] - 1] =
            this.resList[arr[2] - 1][arr[3] - 1] || [];
          this.resList[arr[2] - 1][arr[3] - 1][arr[1]] =
            this.resList[arr[2] - 1][arr[3] - 1][arr[1]] || [];
          this.resList[arr[2] - 1][arr[3] - 1][arr[1]].push(_arr[i].result);
        }

        for (let i = 0; i < 4; i++) {
          this.frameK[this.loadidx - 1][i].opts.fromAnimate = Object.values(
            this.resList[this.loadidx - 1][i][0]
          );
          this.frameK[this.loadidx - 1][i].opts.cycleAnimate = Object.values(
            this.resList[this.loadidx - 1][i][1]
          );
          this.resList[this.loadidx - 1][i][2] &&
            (this.frameK[this.loadidx - 1][i].opts.toAnimate = Object.values(
              this.resList[this.loadidx - 1][i][2]
            ));
        }

        if (this.loadidx == 5) {
          return;
        }
        this.loadidx++;
        this.loadAllPage();
        // this.loadAllPage();
      });
    },
    //loading 开始
    loadingDataStart() {
      let obj = {};
      let data = loadData.loadDataFun();
      let that = this;
      let { TweenMax, TweenLite, TimelineLite } = this.gsap;
      //初始化页面
      for (let x = 1; x <= 5; x++) {
        for (let z = 1; z <= 4; z++) {
          this.page_init(x, z);
        }
      }

      //加载第一题
      let loadv1 = this.rnPage(1, 1);
      let loadv2 = this.rnPage(1, 2);
      let loadv3 = this.rnPage(1, 3);
      let loadv4 = this.rnPage(1, 4);
      data.push(...loadv1, ...loadv2, ...loadv3, ...loadv4);
      // data.push(...loadv1);

      //加载第一题背景动画
      data.push(...loadData.page1_1DataBgFun());

      //加载按钮动画
      data.push(...loadData.btnFrom());

      //加载首页循环
      data.push(...loadData.loadDataCycleFun());

      let preload = new createjs.LoadQueue(false);
      preload.setMaxConnections(5);
      preload.loadManifest(data);
      preload.addEventListener("complete", () => {
        console.log("首页加载完毕");

        //初始化页面
        for (let z = 1; z <= 4; z++) {
          this.page_init(1, z);
          this.frameK[0][z - 1].opts.fromAnimate = Object.values(
            this.resList[0][z - 1][0]
          );
          this.frameK[0][z - 1].opts.cycleAnimate = Object.values(
            this.resList[0][z - 1][1]
          );
          this.resList[0][z - 1][2] &&
            (this.frameK[0][z - 1].opts.toAnimate = Object.values(
              this.resList[0][z - 1][2]
            ));
        }

        this.p1_bg_init(bgArr); //初始化背景
        this.btnFrom_init(btnList);
        this.loadAllPage();
        this.cyclePreload.isLoad = true;

        $('.loadStartBtn').fadeIn(500);


        let flag = false;
        $('.loadStartBtn').on('click',()=>{
          if(flag)return;
          flag = true;

          this.sound.play();
          $('.audio').show();
          TweenMax.to(".load_prog", 0.5, { autoAlpha: 0 });
          this.isStartLoad = true;
          that.loadingTxtAnimate();
          that.loadloop.init();


            that.report("click_story",{path:'young2022'});      

          //         TweenMax.to(".loading", 0.3, { autoAlpha: 0 });
          // TweenMax.to(".page1", 0.3, { autoAlpha: 1 });
          // this.index = 4;
          // this.nextAnswer();
        });

        
        // return;

        // setTimeout(() => {
        

        //   // this.nextPage();

        //   // TweenMax.to(".loading", 0.3, { autoAlpha: 0 });
        //   // TweenMax.to(".page1", 0.3, { autoAlpha: 1 });
        //   // this.index = 4;
        //   // this.nextAnswer();
        // }, 400);
      });
      preload.addEventListener("progress", (e) => {
        if(parseInt(e.progress * 100) > 50 && !this.laodFont){
            this.loadStyle('https://helloyoung.qq.com/young2022/font.css');
            this.laodFont = true;
        }

        that.loadingNumber = parseInt(e.progress * 100);
      });

      //       TweenMax.to(".load_prog", 0.5, { autoAlpha: 0 });

      //               that.loadingTxtAnimate();
      //               that.loadloop.init();
      //               that.cyclePreload = that.loadingDataCycle();
      //  that.loadingNumber++;
      let bgArr = [];
      let btnList = [];

      preload.on("fileload", function (e) {
        if (e.item.id.indexOf("home") != -1) {
          obj[e.item.id] = e.result;
        }
        if (e.item.id.indexOf("bg") != -1) {
          bgArr[e.item.id] = e.result;
        }
        if (e.item.id.indexOf("btn") != -1) {
          btnList[e.item.id] = e.result;
        }
        if (e.item.id.indexOf("page") != -1) {
          let arr = e.item.id.split("_");
          // console.log(arr);
          that.resList[arr[2] - 1] = that.resList[arr[2] - 1] || [];
          that.resList[arr[2] - 1][arr[3] - 1] =
            that.resList[arr[2] - 1][arr[3] - 1] || [];
          that.resList[arr[2] - 1][arr[3] - 1][arr[1]] =
            that.resList[arr[2] - 1][arr[3] - 1][arr[1]] || [];
          that.resList[arr[2] - 1][arr[3] - 1][arr[1]][e.item.id] = e.result;
        }

        if (e.item.id.indexOf("Loadingxh") != -1) {
          that.cyclePreload[e.item.id] = e.result;
        }
      });

      let len = loadData.loadDataFun().length;
      let len1 = loadData.loadDataCycleFun().length;

      this.loadloop = {
        timer: null,
        number: 0,
        isW: false,
        isPlayComplete: false,
        frame: 0,
        pause() {
          cancelAnimationFrame(this.timer);
        },
        loop() {
          // let idx = base64.findIndex((e) => e.id == this.frame);
          if (this.frame > len - 1) {
            this.isPlayComplete = true;
            this.number = 0;
            this.frame = 0;
          }
          //播放完成 & 加载完成 - 播放循环动画
          if (this.isPlayComplete && that.cyclePreload.isLoad) {
            if (that.cyclePreload.isReverse && this.frame <= 0) {
              that.cyclePreload.isReverse = false;
            } else if (this.frame >= len1 - 1) {
              that.cyclePreload.isReverse = true;
            }
            if (this.number == 5) {
              this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
              this.ctx.drawImage(
                that.cyclePreload["Loadingxh" + this.frame],
                0,
                0,
                this.canvas.width,
                this.canvas.height
              );
              that.cyclePreload.isReverse ? this.frame-- : this.frame++;
              //  this.frame++;
              // console.log(cyclePreload.isReverse,this.frame);
              this.number = 0;
            }
            this.number++;
          } else {
            //loading 开始动画
            if (obj["home_" + this.frame]) {
              let img = obj["home_" + this.frame];
              if (this.number == 4) {
                if (!this.isW) {
                  this.canvas.width = img.width;
                  this.canvas.height = img.height;
                  this.isW = true;
                }

                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

                this.ctx.drawImage(
                  img,
                  0,
                  0,
                  this.canvas.width,
                  this.canvas.height
                );
                this.frame++;
                this.number = 0;
              }
              this.number++;
            }
          }

          this.timer = requestAnimationFrame(this.loop.bind(this));
        },
        init() {
          this.canvas = document.getElementById("loadCanvas");
          this.ctx = this.canvas.getContext("2d");

          this.loop();
        },
      };
    },
    //loading 循环
    loadingDataCycle() {
      let data = loadData.loadDataCycleFun();
      let preload = new createjs.LoadQueue(false);
      preload.setMaxConnections(5);
      preload.loadManifest(data);
      preload.addEventListener("complete", () => {
        preload.isLoad = true;

        // this.p1_1_init();
      });
      return preload;
    },

    //loading 文字动画
    loadingTxtAnimate() {
      let { TimelineLite, TweenLite, TweenMax } = this.gsap;
      let h = window.innerHeight;
      let w = window.innerWidth;
      let r = w / 750;

      let tl = new TimelineLite();
      tl.add(TweenLite.to(".loading .t1 .img1 .ani", 0.4, { width: "102%" }));
      tl.add(
        TweenLite.to(".loading .t1 .img2 .ani", 0.5, { width: "102%" }),
        "+=0.4"
      );
      tl.add(
        TweenLite.to(".loading .t1 .img3 .ani", 0.4, { width: "102%" }),
        "+=0.4"
      );
      tl.add(TweenLite.to(".loading .t1", 0.2, { alpha: 0 }), "+=1");
      tl.add(
        TweenLite.to(".loading .t2 .img1 .ani", 0.5, {
          width: "102%",
          onComplete() {
            TweenMax.fromTo(
              ".loading .t2 .img1",
              0.3,
              { scale: 1 },
              { scale: 1.02, repeat: -1, yoyo: true }
            );

            TweenMax.to(".shoushi", 0.3, {
              autoAlpha: 1});
          },
        })
      );

      tl.add(
        TweenLite.to(".loading .t2 .img2 .ani", 0.4, { width: "102%" }),
        "+=0.4"
      );
      tl.add(
        TweenLite.to(".loading .t2 .img3 .ani", 0.6, { width: "102%" }),
        "+=0.4"
      );
      // tl.pause();
    },
    //适配
    cssComp() {
      this.comp = [];

      let h = window.innerHeight;
      let w = window.innerWidth;
      let r = 750 / w;
      this.innerHeight = h;

      // console.log("666666666", h, this.comp);

      if (h * r > 1334) {
        this.comp.push("min-css1334");
      }
      if (h * r < 1410) {
        this.comp.push("max-css1410");
      }
      if (h * r < 1380) {
        this.comp.push("max-css1380");
      }

      if (h * r < 1334) {
        this.comp.push("max-css1334");
      }

      if (h * r < 1300) {
        this.comp.push("max-css1300");
      }
      if (h * r < 1270) {
        this.comp.push("max-css1270");
      }
      if (h * r < 1285) {
        this.comp.push("max-css1285");
      }
      if (h * r < 1230) {
        this.comp.push("max-css1230");
      }
      if (h * r < 1220) {
        this.comp.push("max-css1220");
      }
      if (h * r < 1200) {
        this.comp.push("max-css1200");
      }
      if (h * r < 1160) {
        this.comp.push("max-css1160");
      }
    },
    //loading 到 page1-1
    nextPage() {
      this.Toast.loading({ forbidClick: true, duration: 0 });
      if (
        this.bgList[0] &&
        this.resList[0][0].length === 3 &&
        this.btnList.isComp
      ) {
        console.log("加载完成,进入下一页");
        let { TweenMax } = this.gsap;
        TweenMax.to(".loading", 0.3, { autoAlpha: 0 });
        TweenMax.to(".page1", 0.3, { autoAlpha: 1 });
        this.isTap = false;

        this.loadloop && this.loadloop.pause();

        $(".p1-1-box,.tmxz1").css({
          opacity: 1,
          visibility: "visible",
        });

        this.frameK[0][0].play();
        let idx = this.opsIdx[this.index];
        TweenMax.set(`.p${this.index + 1}-option .p1-optiom-${idx + 1} .a2`, {
          width: "0%",
        });
        TweenMax.set(`.p${this.index + 1}-option .p1-optiom-${idx + 1} .a1`, {
          width: "0%",
        });
        this.page_animate();
        this.Toast.clear();

        // this.page_init(1, 2); //加载第1题第2项
        // this.page_init(2, 1); //加载第2题第1项

        this.progress();

        this.tipsWork();
      } else {
        setTimeout(this.nextPage, 200);
      }
    },

    tipsWork() {
      cancelAnimationFrame(this.tipsTimer);

      let that = this;
      let numbr = 0;

      function loop() {
        if (numbr % 120 == 0 && numbr !== 0) {
          let { opsIdx, index } = that;
          if (opsIdx[index] === 3) {
            cancelAnimationFrame(that.tipsTimer);
            return;
          }
          that.x_nextOption(index, opsIdx[index] + 1, true);
        }
        numbr++;
        that.tipsTimer = requestAnimationFrame(loop);
      }
      loop();
    },

    progress(n) {
      // console.log('progress');
      let { seed } = this.bgoption;

      if (this.bgList[0] && !this.isOptionbg) {

        let len = Object.keys(this.bgList[0]).length

        if (this.bgoption.number === seed) {
          if (this.bgoption.frame > len - 1) {
            this.bgoption.frame = 0;
          }
          let { width: w, height: h } = this.bgCanvas[0].canvas;
          this.bgCanvas[0].ctx.clearRect(0, 0, w, h);
          this.bgCanvas[0].ctx.drawImage(
            this.bgList[0]["bg_" + this.bgoption.frame],
            0,
            0,
            w,
            h
          );
          this.bgoption.number = 0;
          this.bgoption.frame++;
        }
        this.bgoption.number++;
      }

      let { seed: s } = this.btnoption;

      if (this.btnList.img && this.btnList.isPlay) {
        if (this.btnoption.number === s) {
          // if (
          //   this.btnList.state == 0 &&
          //   this.btnoption.frame >
          //     this.btnList.img[this.btnList.state].length - 1
          // ) {
          //   this.btnoption.frame = 0;
          //   this.btnList.state = 1;
          // }

          if (this.btnoption.frame > this.btnList.img.length - 1) {
            this.btnList.isPlay = false;
            this.btnoption.frame = this.btnList.img.length - 1;
            // this.btnoption.isReverse = 1;
          }
          //  else if (this.btnoption.frame < 0) {
          //   this.btnoption.frame = 0;
          //   this.btnoption.isReverse = 0;
          // }
          let { width: w, height: h } = this.btnCanvas.canvas;
          this.btnCanvas.ctx.clearRect(0, 0, w, h);
          this.btnCanvas.ctx.drawImage(
            this.btnList.img[this.btnoption.frame],
            0,
            0,
            w,
            h
          );
          this.btnoption.number = 0;
          this.btnoption.frame++;
        }
        this.btnoption.number++;
      }
      this.timer = requestAnimationFrame(this.progress.bind(this));
    },

    //第一题背景
    async p1_bg_init(bgarr) {
      // let p = await imgLoad(loadData.page1_1DataBgFun());
      // let ay = loadData.page1_1DataBgFun().map((e) => {
      //   return p.getResult(e.id);
      // });
      // console.log(ay);
      let ay = bgarr;
      console.log("第一题背景加载完成");

      let $canvas = document.getElementById("p1_bg");
      $canvas.width = 750;
      $canvas.height = 1334;
      this.bgCanvas[0] = {
        canvas: $canvas,
        ctx: $canvas.getContext("2d"),
      };

      this.bgList[0] = ay;
    },

    rnPage(i, b) {
      let p1 =
        loadData[`page${i}_${b}DataFromFun`] &&
        loadData[`page${i}_${b}DataFromFun`]();
      let p2 =
        loadData[`page${i}_${b}DataCycleFun`] &&
        loadData[`page${i}_${b}DataCycleFun`]();
      let p3 =
        loadData[`page${i}_${b}DataToFun`] &&
        loadData[`page${i}_${b}DataToFun`]();

      if (p1) {
        for (let v in p1) {
          p1[v].id = `page_0_${i}_${b}_${p1[v].id}`;
        }
      }
      if (p2) {
        for (let v in p2) {
          p2[v].id = `page_1_${i}_${b}_${p2[v].id}`;
        }
      }
      if (p3) {
        for (let v in p3) {
          p3[v].id = `page_2_${i}_${b}_${p3[v].id}`;
        }
      }

      return [...p1, ...p2, ...(p3 || [])];
    },

    async page_init(i, b) {
      let that = this;
      const fromCallback = () => {
        console.log("第一阶段结束");
        let { TweenMax, TweenLite } = this.gsap;
        // TweenMax.to(".icon-right,.icon-left", 0.5, { autoAlpha: 1 });
        this.isTap = false;
      };
      let frame = new frameVideo({
        canvas: document.getElementById(`p${i}_${b}_canvas`),
        w: 750,
        h: 1334,
        fromCallback,
        id: `page${i}_${b}`,
      });

      this.frameK[i - 1][b - 1] = frame;

      return;

      let loadarr = [];

      loadData[`page${i}_${b}DataFromFun`] &&
        loadarr.push(loadData[`page${i}_${b}DataFromFun`]());
      loadData[`page${i}_${b}DataCycleFun`] &&
        loadarr.push(loadData[`page${i}_${b}DataCycleFun`]());
      loadData[`page${i}_${b}DataToFun`] &&
        loadarr.push(loadData[`page${i}_${b}DataToFun`]());

      // console.log('loadarr',loadarr);

      if (
        this.resList[i - 1][b - 1] &&
        this.resList[i - 1][b - 1].length === loadarr.length
      ) {
        frame.opts.fromAnimate = this.resList[i - 1][b - 1][0];
        frame.opts.cycleAnimate = this.resList[i - 1][b - 1][1];
        this.resList[i - 1][b - 1][2] &&
          (frame.opts.toAnimate = this.resList[i - 1][b - 1][2]);
      } else {
        let resList = [];
        (async () => {
          for (let key in loadarr) {
            let p = await imgLoad(loadarr[key]);
            let ay = loadarr[key].map((e) => {
              return p.getResult(e.id);
            });
            resList.push(ay);
            this.resList[i - 1][b - 1] = this.resList[i - 1][b - 1] || [];
            this.resList[i - 1][b - 1].push(ay);
            // frame.opts[str[resList.length - 1]] = ay;
            if (resList.length === loadarr.length) {
              frame.opts.fromAnimate = resList[0];
              frame.opts.cycleAnimate = resList[1];
              resList[2] && (frame.opts.toAnimate = resList[2]);
              console.log("第" + i + "题第" + b + "选项加载完成");
            }

            // console.log(this.resList);
          }
        })();
      }
    },
    page_animate() {
      let { TimelineLite, TweenLite, TweenMax } = this.gsap;
      let that = this;
      let tl = new TimelineLite({
        onComplete() {
          that.btnList.isPlay = true;
        },
      });

      if (!this.isDyc[this.index]) {
        tl.add(
          TweenLite.fromTo(
            `.page1 .p${this.index + 1}-1-1 .ani`,
            0.2,
            { width: "0%" },
            { width: "102%" }
          )
        );
        tl.add(
          TweenLite.fromTo(
            `.page1 .p${this.index + 1}-1-2 .ani`,
            0.2,
            { width: "0%" },
            { width: "102%" }
          ),
          "+=0.1"
        );
      }

      let idx = this.opsIdx[this.index] || 0;
      if ($(`.page1 .p${this.index + 1}-${idx + 1}-3 .ani`)[0]) {
        tl.add(
          TweenLite.fromTo(
            `.page1 .p${this.index + 1}-${idx + 1}-3 .ani`,
            0.2,
            { width: "0%" },
            { width: "102%" }
          ),
          "+=0.1"
        );
      }

      for (let i = 0; i < 4; i++) {
        if (idx == i) {
          // TweenMax.set(`.p${this.index + 1}-option .p1-optiom-${idx + 1} .a1`, {
          //   width: "100%",
          // });
          tl.add(
            TweenLite.fromTo(
              `.p${this.index + 1}-option .p1-optiom-${idx + 1} .a2`,
              0.4,
              { width: "0%" },
              {
                width: "102%",
                onComplete() {
                  TweenMax.set(
                    `.p${that.index + 1}-option .p1-optiom-${idx + 1} .a1`,
                    {
                      width: "100%",
                    }
                  );
                },
              }
            )
          );

          TweenMax.fromTo(
            `.tmxz${this.index + 1} .yuanq`,
            0.3,
            {
              opacity: 0,
            },
            {
              opacity: 1,
              delay: 0.5 * (idx + 1),
            }
          );
        } else {
          // TweenMax.set(`.p${this.index + 1}-option .p1-optiom-${i + 1} .a2`, {
          //   width: "100%",
          // });
          tl.add(
            TweenLite.fromTo(
              `.p${this.index + 1}-option .p1-optiom-${i + 1} .a1`,
              0.4,
              { width: "0%" },
              {
                width: "102%",
                onComplete() {
                  TweenMax.set(
                    `.p${that.index + 1}-option .p1-optiom-${i + 1} .a2`,
                    {
                      width: "100%",
                    }
                  );
                },
              }
            )
          );
        }
      }

      this.isDyc[this.index] = 1;

      // this.btnList.isPlay
    },

    x_nextOption(a, b, c) {
      if (!c) {
        cancelAnimationFrame(this.tipsTimer);
      }

      if (this.opsIdx[a] === b) return;

      let prve = this.opsIdx.find((e) => typeof e !== undefined);

      if (prve > b) {
        console.log("上一个");
        this.prveOption(this.opsIdx[a], b);
      } else {
        console.log("下一个");
        this.nextOption(this.opsIdx[a], b);
      }

      let _arr = JSON.parse(JSON.stringify(this.opsIdx));
      _arr[a] = b;
      this.opsIdx = _arr;
    },

    //下一个选项
    nextOption(a, b) {
      let that = this;

      this.Toast.loading({ forbidClick: true, duration: 0 });
      if (
        (b != 3 &&
          this.resList[this.index] &&
          this.resList[this.index][b] &&
          this.resList[this.index][b].length === 3) ||
        (b == 3 &&
          this.resList[this.index][b] &&
          this.resList[this.index][b].length === 2)
      ) {
        this.frameK[this.index][a].state = 2;
        this.frameK[this.index][a].frame = 0;
        this.frameK[this.index][a].isReverse = 0;

        let { TweenMax, TweenLite, TimelineLite } = this.gsap;

        TweenLite.to(
          ".page1 .p" + (this.index + 1) + "-" + (a + 1) + "-box",
          0.3,
          {
            autoAlpha: 0,
            delay: 0.4,
            onComplete() {
              // that.page_animate();
            },
          }
        );

        // this.opsIdx++;
        TweenLite.to(
          ".page1 .p" + (this.index + 1) + "-" + (b + 1) + "-box",
          0.3,
          {
            autoAlpha: 1,
            delay: 0.4,
            onStart() {
              that.frameK[that.index][b] &&
                that.frameK[that.index][b].clearFrame();

              that.frameK[that.index][b] && that.frameK[that.index][b].play();
            },
          }
        );

        let { w, h } = this.frameK[this.index][b].opts;
        this.frameK[this.index][b]._ctx.clearRect(0, 0, w, h);

        // TweenMax.set(`.p${this.index + 1}-${b + 1}-box .ani`, {
        //   width: "0%",
        // });

        this.Toast.clear();
      } else {
        setTimeout(this.nextOption, 200);
      }
    },
    //上一个选项
    prveOption(a, b) {
      let that = this;
      // if (that.isTap) return;
      // that.isTap = true;

      let { TweenMax, TweenLite, TimelineLite } = this.gsap;
      TweenLite.to(
        ".page1 .p" + (this.index + 1) + "-" + (a + 1) + "-box",
        0.3,
        {
          autoAlpha: 0,
        }
      );
      // TweenMax.to(".icon-right,.icon-left", 0.5, {
      //   autoAlpha: 0,
      // });

      this.frameK[this.index][a].clearFrame();
      // this.opsIdx--;

      let { w, h } = this.frameK[this.index][b].opts;
      this.frameK[this.index][b]._ctx.clearRect(0, 0, w, h);

      that.frameK[that.index][b].clearFrame();
      that.frameK[that.index][b].play();
      TweenLite.to(
        ".page1 .p" + (this.index + 1) + "-" + (b + 1) + "-box",
        0.3,
        {
          autoAlpha: 1,
          onComplete() {
            // that.isTap = false;
            // that.page_animate();
          },
          onStart() {},
        }
      );
      // TweenMax.set(`.p${this.index + 1}-${b + 1}-box .ani`, {
      //   width: "0%",
      // });
    },

    //上一个题
    prveAnswer() {
      let { TweenMax, TweenLite, TimelineLite } = this.gsap;
      let that = this;
      let idx = this.opsIdx[this.index];
      this.frameK[this.index][idx].clearFrame();
      TweenLite.to(".tmxz" + (this.index + 1), 0.3, {
        autoAlpha: 0,
      });

      let { w, h } = this.frameK[this.index][idx].opts;
      this.frameK[this.index][idx]._ctx.clearRect(0, 0, w, h);

      this.index--;

      idx = this.opsIdx[this.index];

      if (this.index != 0) {
        this.isOptionbg = true;
      } else {
        this.isOptionbg = false;
        $(".returnprve").fadeOut(200);
      }

      // let tz =
      //   $(`.p${this.index + 1}-${this.opsIdx + 1}-box .ani`)
      //     .parent()
      //     .position().top -
      //   6 * (window.innerWidth / 750);
      // $(".page1 .animate1_1,.page1 .animate1_2").css("top", tz + "px");

      // console.log($(`.p${this.index+1}-option .optiom .a1`));

      TweenMax.set(`.p${this.index + 1}-option .optiom .a1`, {
        width: "0%",
      });
      TweenMax.set(`.p${this.index + 1}-option .optiom .a2`, {
        width: "0%",
      });

      TweenLite.to(".tmxz" + (this.index + 1), 0.3, {
        autoAlpha: 1,
        onComplete() {
          // that.isTap = false;
          that.page_animate();
        },
      });

      this.frameK[this.index][idx] && this.frameK[this.index][idx].clearFrame();

      this.frameK[this.index][idx] && this.frameK[this.index][idx].play();

      this.btnoption = {
        seed: 6,
        number: 0,
        frame: 0,
      };
      let { width: ws, height: hs } = this.btnCanvas.canvas;
      this.btnCanvas.ctx.clearRect(0, 0, ws, hs);

      $(".p" + (this.index + 1) + "-" + (idx + 1) + "-box").css({
        opacity: 1,
        visibility: "visible",
      });

      TweenMax.set(".tmxz" + (this.index + 1) + " .pbox", {
        autoAlpha: 0,
      });

      TweenMax.set(
        ".tmxz" +
          (this.index + 1) +
          " .p" +
          (this.index + 1) +
          "-" +
          (idx + 1) +
          "-box",
        {
          autoAlpha: 1,
        }
      );

      // TweenMax.set(`.p${this.index + 1}-${this.opsIdx + 1}-box .ani`, {
      //   width: "0%",
      // });
      TweenMax.set(`.tmxz${this.index + 1}>div>.ani`, {
        width: "0%",
      });

      TweenMax.set(`.tmxz${this.index + 1} .yuanq`, {
        opacity: 0,
      });
      this.btnList.isPlay = false;
      this.btnList.state = 0;

      this.isDyc[this.index] = 0;
      cancelAnimationFrame(this.timer);
      this.progress();
    },

    tiaozhjuan() {
      let ADTAG = getUrlParam("ADTAG");

      let arr = [4, 3, 5, 2, 1];
      let _arr = arr.map((e) => {
        return this.optionArr[e - 1];
      });
      _arr = "0" + _arr.join("");
      location.href =
        "https://helloyoung.qq.com/answer.html?subject=" +
        _arr +
        "&ADTAG=" +
        ADTAG;
    },

    //下一个题
    nextAnswer(bc) {
      let { TweenMax, TweenLite, TimelineLite } = this.gsap;
      let that = this;

      cancelAnimationFrame(this.tipsTimer);

      let isJump = getUrlParam("jump");
      if (isJump) {
        this.optionArr = isJump.split("");
      } else {
        this.optionArr[this.index] =
          this.optionData[this.index] == this.opsIdx[this.index] ? 1 : 0;
      }

      // let test = "11001";
      // this.optionArr = test.split("");
      // this.name = "伟大时代所所";
      // this.headimgurl ="https://thirdwx.qlogo.cn/mmopen/vi_32/qrg3Uw9E3wZLYQkiamibWKZcTk5NyhhWStytEibBqqjGMFpzKg1C58DB8svZenleejkSLUBxX8StxZrOre0WdaFjQ/132";

      if (this.index == 4) {
        if (this.name) {
          localStorage.setItem("name", this.name);
        } else {
          let name = localStorage.getItem("name");
          if (name) {
            this.name = name;
          }
        }

        $(".bl2,.returnprve").fadeOut(500);
        $(".bl1").fadeIn(500);


        // canvasToImg();

        txjsdk.handleGetUserInfo((userinfo) => {
          console.log("userinfo", userinfo);
          if (userinfo) {
            this.$root.openid = userinfo.openid;
            // this.$root.name = userinfo.nickname;
            this.headimgurl = userinfo.headimgurl;
            canvasToImg();
          }
        }, this.optionArr.join(""));

        function canvasToImg() {
          if (that.llflag) return;
          that.llflag = true;

          that.loadGs();
          function nextyem() {
            util.clearTimeout(that._nm);
            that._nm = util.setTimeout(() => {
              if (that.ToastFlag) {
                next();
              } else {
                nextyem();
              }
            }, 120);
          }
          nextyem();

          // let na = 0;
          // let isyi = 1;
          // console.log($('.guoduye .gy').eq(na));

          // const loop = () => {
          //   // if (na != 0 || !isyi) {
          //   //   TweenMax.fromTo($('.guoduye .gy').eq(na)[0], 1, { opacity: 1 }, { opacity: 0 });
          //   // }
          //   // na++;
          //   // TweenMax.to($('.guoduye .gy').eq(na)[0], 1,{ opacity:0 });
          //  if(na != 0){
          //     TweenMax.to($('.guoduye .gy').eq(na - 1)[0], .3,  { opacity:0 });
          //  }
          //   if (na > 4) {
          //     na = 0;
          //   }
          //   TweenMax.to($('.guoduye .gy').eq(na)[0], .3,  { opacity:1 });
          //   na++;
          // };
          // that.nva = util.setInterval(loop, 60);

          // next();
          // that.ToastFlag

          that.frameK[that.index][that.opsIdx[that.index]] &&
            that.frameK[that.index][that.opsIdx[that.index]].clearFrame();
          cancelAnimationFrame(that.timer);
          let number = that.optionArr.filter((e) => e == 1).length;
          console.log("答题:", that.optionArr);
          console.log("答对", number);
          let img = require("./assets/img/jg" +
            number +
            "/pgd_a_" +
            that.optionArr.join("") +
            ".png");

          // that.Toast.loading({
          //   forbidClick: true,
          //   duration: 0,
          //   message: "生成中...",
          // });
          let data = [
            {
              id: "context",
              src: img,
            },
            {
              id: "border",
              src: require("./assets/img/share_border.png"),
            },
            {
              id: "bg",
              src: require("./assets/img/bg.jpg"),
            },
            {
              id: "ercode",
              src: require("./assets/img/ercode.png"),
            },
            {
              id: "logo",
              src: require("./assets/img/logo.png"),
            },
          ];

          let preload = new createjs.LoadQueue(false);
          preload.setMaxConnections(5);
          preload.loadManifest(data);
          preload.addEventListener("complete", () => {
            // that.Toast.clear();
            that.ToastFlag = true;
          });

          function next() {
            // util.clearInterval(that.nva);
            for (let i in that.optionArr) {
              if (that.optionArr[i] == 1) {
                $(".gushi .gushi-box .gus-move .img").eq(i).find(".gs2").show();
              } else {
                $(".gushi .gushi-box .gus-move .img").eq(i).find(".gs1").show();
              }
            }
            $(".border-center-r").hide();
            $(".page2 .border-center-r").show();

            TweenMax.to(".border .bottom", 0.5, {
              autoAlpha: 1,
            });
            TweenMax.to(".page1", 0.5, {
              autoAlpha: 0,
            });
            TweenMax.to(".page2", 0.5, {
              autoAlpha: 1,
            });
            $(".p-xta span").text(that.name);

            $(".page2 .page1_box").addClass(
              "jg" + number + "_" + that.optionArr.join("")
            );

            let r = window.innerWidth / 750;
            let top = [797, 746, 750, 704, 700, 667];
            let no = 840;

            let shareTop = [838, 778, 782, 736, 738, 697];
            let shareFontSize = [37, 35, 35, 35, 37, 37];
            let shareno = 876;
            let size = number == 0 ? 37 : shareFontSize[number - 1];

               let y = number == 0 ? shareno : shareTop[number - 1];
            var u = navigator.userAgent;
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            $(".p-xta").css("font-size", size*r + "px");
            if(isiOS){
              $(".p-xta").css("font-weight", "bold");
            }
            if (number == 0) {
              $(".p-xta").css("top", no * r + "px");
            } else {
              $(".p-xta").css("top", top[number - 1] * r + "px");

              if (number != 1) {
                // let elarr = [];
                // for (let key in that.optionArr) {
                //   if (that.optionArr[key] == 1) {
                //     let m = key * 1 + 1;
                //     $(".bian.t" + m).css("opacity", 0);
                //     elarr.push(".bian.t" + m);
                //   }
                // }
                // let na = 0;
                // let isyi = 1;
                // const loop = () => {
                //   console.log(na);
                //   if (na != 0 || !isyi) {
                //     TweenMax.fromTo(
                //       elarr[na],
                //       1,
                //       { opacity: 1 },
                //       { opacity: 0 }
                //     );
                //   }
                //   na++;
                //   if (na > elarr.length - 1) {
                //     na = 0;
                //     isyi = 0;
                //   }
                //   TweenMax.fromTo(elarr[na], 1, { opacity: 0 }, { opacity: 1 });
                // };
                // util.setInterval(loop, 120);
              }
            }

            let canvas = document.createElement("canvas");
            // let canvas = document.getElementById("canvas");
            let ctx = canvas.getContext("2d");
            canvas.width = 750;
            canvas.height = 1334;

            let img_bg = preload.getResult("bg");
            ctx.drawImage(img_bg, 0, 0, img_bg.width, img_bg.height);

            let img_border = preload.getResult("border");
            ctx.drawImage(
              img_border,
              0,
              0,
              img_border.width,
              img_border.height
            );
            let img_context = preload.getResult("context");
            ctx.drawImage(
              img_context,
              0,
              0,
              img_context.width,
              img_context.height
            );

            let img_ercode = preload.getResult("ercode");
            ctx.drawImage(
              img_ercode,
              637,
              1198,
              img_ercode.width,
              img_ercode.height
            );

            let img_logo = preload.getResult("logo");
            ctx.drawImage(img_logo, 0, 1240, img_logo.width, img_logo.height);

         
            if (isiOS) {
              ctx.font = "" + size + "px fzjz ";
            } else {
              ctx.font = "" + size + "px fzjz ";
            }

            ctx.fillStyle = "#404040";
            ctx.textAlign = "center";
            ctx.fillText(
              "我家小宝贝 " + that.name + " 的大师DNA里",
              (canvas.width + 54) / 2,
              y
            );

            let txtW = ctx.measureText(
              "我家小宝贝 " + that.name + " 的大师DNA里"
            );
            // let img_headimgurl = preload.getResult("headimgurl");
            // console.log('img_headimgurl',img_headimgurl);

            let imgage = new Image();
            imgage.crossOrigin = "anonymous";
            imgage.onload = function () {
              let x = (canvas.width - txtW.width) / 2 - 5;
              let yx = y - 16;
              ctx.save();

              let size = 2 * 27;
              ctx.arc(x, yx, 27, 0, 2 * Math.PI);
              ctx.clip();
              ctx.drawImage(imgage, x - 27, yx - 27, size, size);

              ctx.restore();

              let base64 = canvas.toDataURL("image/png");
              $(".saveImage").attr("src", base64);
            };
            imgage.src = that.headimgurl;
          }

          $(".xuhao").attr("src", img);
        }

        return;
      }

      this.Toast.loading({ forbidClick: true, duration: 0 });

      // this.opsIdx[this.index] = this.opsIdx[this.index] || 0;

      console.log(this.resList,this.opsIdx[this.index + 1]);

      let iddd = this.opsIdx[this.index + 1];

      if (
        (iddd !=3 && this.resList[this.index + 1][this.opsIdx[this.index + 1]].length === 3) ||
        iddd ==3 && this.resList[this.index + 1][this.opsIdx[this.index + 1]].length === 2
      ) {
        let that = this;
        this.frameK[this.index][this.opsIdx[this.index + 1]].clearFrame();

        this.btnoption = {
          seed: 6,
          number: 0,
          frame: 0,
        };
        let { width: w, height: h } = this.btnCanvas.canvas;
        this.btnCanvas.ctx.clearRect(0, 0, w, h);
        cancelAnimationFrame(this.timer);

        TweenLite.to(".tmxz" + (this.index + 1), 0.3, {
          autoAlpha: 0,
        });
        // TweenMax.killTweensOf(".icon-right,.icon-left");
        // TweenMax.to(".icon-right,.icon-left", 0.5, {
        //   autoAlpha: 0,
        // });

        $(".returnprve").fadeIn(200);

        this.index++;
        // console.log("index", this.index);

        // .p${this.index + 1}-${this.opsIdx[this.index] + 1}-box .ani

        // let tz =
        //   $(`.p${this.index + 1}-${this.opsIdx[this.index] + 1}-box .ani`)
        //     .parent()
        //     .position().top -
        //   6 * (window.innerWidth / 750);
        // $(".page1 .animate1_1,.page1 .animate1_2").css("top", tz + "px");

        if (this.index != 0) {
          this.isOptionbg = true;
        } else {
          this.isOptionbg = false;
        }
        this.bgoption = {
          seed: 6,
          number: 0,
          frame: 0,
        };
        let { width: bg_w, height: bg_h } = this.bgCanvas[0].canvas;
        this.bgCanvas[0].ctx.clearRect(0, 0, bg_w, bg_h);


        TweenLite.to(".tmxz" + (this.index + 1), 0.3, {
          autoAlpha: 1,
          onComplete() {
            // that.isTap = false;
            that.page_animate();
          },
        });

        // if (!this.frameK[this.index][this.opsIdx[this.index] + 1]) {
        //   that.page_init(that.index + 1, that.opsIdx + 2); //加载下一个选项
        // }

        // if (!this.frameK[this.index + 1][this.opsIdx[this.index]]) {
        //   if (that.index != 4) {
        //     that.page_init(that.index + 2, that.opsIdx + 1); //加载下一页第一个
        //   }
        // }

        console.log('opsIdx',this.index,this.opsIdx[this.index]);


        this.frameK[this.index][this.opsIdx[this.index]] &&
          this.frameK[this.index][this.opsIdx[this.index]].clearFrame();

        this.frameK[this.index][this.opsIdx[this.index]] &&
          this.frameK[this.index][this.opsIdx[this.index]].play();

        $(".p" + (this.index + 1) + "-1-box").css({
          opacity: 1,
          visibility: "visible",
        });
        TweenMax.set(".tmxz" + (this.index + 1) + " .pbox", {
          autoAlpha: 0,
        });

        TweenMax.set(
          ".tmxz" + (this.index + 1) + " .p" + (this.index + 1) + "-"+(this.opsIdx[this.index] + 1)+"-box",
          {
            autoAlpha: 1,
          }
        );
        let idx = this.opsIdx[this.index];
        TweenMax.set(`.p${this.index + 1}-option .a1`, {
          width: "0%",
        });
        TweenMax.set(`.p${this.index + 1}-option .a2`, {
          width: "0%",
        });
        // TweenMax.set(`.p${this.index + 1}-${this.opsIdx[this.index] + 1}-box .ani`, {
        //   width: "0%",
        // });
        TweenMax.set(`.tmxz${this.index + 1} .yuanq`, {
          opacity: 0,
        });
        TweenMax.set(`.tmxz${this.index + 1}>div>.ani`, {
          width: "0%",
        });
        this.btnList.isPlay = false;
        this.btnList.state = 0;

        this.isDyc[this.index] = 0;

        cancelAnimationFrame(this.timer);
        this.progress();

        this.Toast.clear();
      } else {
        setTimeout(this.nextAnswer, 200);
      }
    },

    //按钮动画
    async btnFrom_init(btnArr) {
      // let loadarr = [loadData.btnFrom(), loadData.btnCycle()];
      // let resList = [];
      let $canvas = document.getElementById("btn");
      $canvas.width = 150;
      $canvas.height = 80;
      this.btnCanvas = {
        canvas: $canvas,
        ctx: $canvas.getContext("2d"),
      };

      Object.keys(btnArr).forEach((e) => {
        this.btnList.img.push(btnArr[e]);
      });

      this.btnList.isComp = true;
      // (async () => {
      //   for (let key in loadarr) {
      //     console.log(loadarr[key]);

      //     let p = await imgLoad(loadarr[key]);
      //     console.log(p);

      //     let ay = loadarr[key].map((e) => {
      //       return p.getResult(e.id);
      //     });
      //     resList.push(ay);
      //     this.btnList.img.push(ay);
      //     if (resList.length === 2) {

      //       console.log("按钮加载完成");
      //     }
      //   }
      // })();
    },
  },
};
</script>

<style lang="less" scoped>
</style>